import React, { useState } from 'react';
import { TextField, Button, Grid, Typography, Tab, Tabs, Box,Paper } from '@mui/material';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import './CreateFoodSupplier.css'; // Import CSS for additional styles

import HeaderMenu from '../Header/HeaderMenu';
import { useLocation } from 'react-router-dom';

const CreateFoodSupplier = ({ isDialog = false, foodSupplier }) => {
  const location = useLocation();
  const disableHeader = location.state?.disableHeader || false; // Get the disableHeader flag from location

  const [formState, setFormState] = useState({
    companyName: foodSupplier?.companyName || '',
    foodSupplierName: foodSupplier?.name || '',
    city: foodSupplier?.city || '',
    state: foodSupplier?.state || '',
    country: foodSupplier?.country || '',
    phoneNumber: foodSupplier?.phoneNumber || '',
    mobileNumber: foodSupplier?.mobileNumber || '',
    images: foodSupplier?.images || [],
    location: foodSupplier?.location || '',
    menu: foodSupplier?.menu || {
      monday: { date: '', breakfast: [], lunch: [], dinner: [] },
      tuesday: { date: '', breakfast: [], lunch: [], dinner: [] },
      wednesday: { date: '', breakfast: [], lunch: [], dinner: [] },
      thursday: { date: '', breakfast: [], lunch: [], dinner: [] },
      friday: { date: '', breakfast: [], lunch: [], dinner: [] },
      saturday: { date: '', breakfast: [], lunch: [], dinner: [] },
      sunday: { date: '', breakfast: [], lunch: [], dinner: [] },
    },
  });

  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleMenuChange = (day, meal, index, event) => {
    const { name, value } = event.target;
    const updatedMeal = [...formState.menu[day][meal]];
    updatedMeal[index] = { ...updatedMeal[index], [name]: value };

    setFormState((prevState) => ({
      ...prevState,
      menu: {
        ...prevState.menu,
        [day]: {
          ...prevState.menu[day],
          [meal]: updatedMeal,
        },
      },
    }));
  };

  const addMenuItem = (day, meal) => {
    setFormState((prevState) => ({
      ...prevState,
      menu: {
        ...prevState.menu,
        [day]: {
          ...prevState.menu[day],
          [meal]: [...prevState.menu[day][meal], { item: '', price: '' }],
        },
      },
    }));
  };

  const handleDateChange = (day, event) => {
    const { value } = event.target;
    setFormState((prevState) => ({
      ...prevState,
      menu: {
        ...prevState.menu,
        [day]: { ...prevState.menu[day], date: value },
      },
    }));
  };

  const handleImageChange = (event) => {
    const files = Array.from(event.target.files);
    setFormState((prevState) => ({
      ...prevState,
      images: [...prevState.images, ...files],
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log('Form Submitted', formState);
  };

  return (
   
   
    <div className="food-supplier">
      {/* Conditionally render HeaderMenu based on isDialog prop */}
       {!isDialog && !disableHeader && <HeaderMenu />}
	   <Paper className="create-food-supplier-layout" elevation={3}>
      <Typography variant="h6" gutterBottom>
        {foodSupplier ? 'Edit Food Supplier Details' : 'Create New Food Supplier'}
      </Typography>

      <form onSubmit={handleSubmit}>
        <Tabs
          value={activeTab}
          onChange={(event, newValue) => setActiveTab(newValue)}
          aria-label="Food Supplier Details Tabs"
          variant="fullWidth"
          centered
        >
          <Tab label="General Info" />
          <Tab label="Contact Info" />
          <Tab label="Images" />
          <Tab label="Location" />
          <Tab label="Menu" />
        </Tabs>

        <Box p={3}>
          {/* General Info */}
          {activeTab === 0 && (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Company Name"
                  name="companyName"
                  value={formState.companyName}
                  onChange={handleChange}
                  fullWidth
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Food Supplier Name"
                  name="foodSupplierName"
                  value={formState.foodSupplierName}
                  onChange={handleChange}
                  fullWidth
                  required
                />
              </Grid>
            </Grid>
          )}

          {/* Contact Info */}
          {activeTab === 1 && (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Phone Number"
                  name="phoneNumber"
                  value={formState.phoneNumber}
                  onChange={handleChange}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Mobile Number"
                  name="mobileNumber"
                  value={formState.mobileNumber}
                  onChange={handleChange}
                  fullWidth
                />
              </Grid>
            </Grid>
          )}

          {/* Images */}
          {activeTab === 2 && (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <input
                  accept="image/*"
                  id="upload-images"
                  type="file"
                  multiple
                  onChange={handleImageChange}
                  style={{ display: 'none' }}
                />
                <label htmlFor="upload-images">
                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    startIcon={<PhotoCameraIcon />}
                  >
                    Upload Images
                  </Button>
                </label>
              </Grid>
              {formState.images.length > 0 && (
                <Grid item xs={12}>
                  <Typography variant="h6">Uploaded Images:</Typography>
                  <Grid container spacing={2}>
                    {formState.images.map((image, index) => (
                      <Grid item xs={12} sm={4} key={index}>
                        <img
                          src={URL.createObjectURL(image)}
                          alt={`Uploaded ${index}`}
                          style={{
                            width: '100%',
                            height: 'auto',
                            borderRadius: '4px',
                          }}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              )}
            </Grid>
          )}

          {/* Location */}
          {activeTab === 3 && (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  label="Location Description"
                  name="location"
                  value={formState.location}
                  onChange={handleChange}
                  fullWidth
                  multiline
                  rows={4}
                />
              </Grid>
            </Grid>
          )}

          {/* Menu */}
          {activeTab === 4 && (
            <Grid container spacing={3}>
              <Typography variant="h6" sx={{ width: '100%', marginBottom: '20px' }}>Menu for the Coming Week</Typography>
              {Object.keys(formState.menu).map((day) => (
                <Grid container spacing={2} key={day} sx={{ marginBottom: '20px', padding: '10px', border: '1px solid #ccc', borderRadius: '8px' }}>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                      {day.charAt(0).toUpperCase() + day.slice(1)}'s Menu
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Date"
                      name="date"
                      type="date"
                      value={formState.menu[day].date}
                      onChange={(event) => handleDateChange(day, event)}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  {['breakfast', 'lunch', 'dinner'].map((meal) => (
                    <Grid item xs={12} key={meal}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', marginTop: '10px' }}>{meal.charAt(0).toUpperCase() + meal.slice(1)}</Typography>
                      {formState.menu[day][meal].map((item, index) => (
                        <Grid container spacing={2} key={index} sx={{ marginTop: '5px' }}>
                          <Grid item xs={6} sm={4}>
                            <TextField
                              label="Item"
                              name="item"
                              value={item.item}
                              onChange={(event) => handleMenuChange(day, meal, index, event)}
                              fullWidth
                            />
                          </Grid>
                          <Grid item xs={6} sm={4}>
                            <TextField
                              label="Price"
                              name="price"
                              type="number"
                              value={item.price}
                              onChange={(event) => handleMenuChange(day, meal, index, event)}
                              fullWidth
                            />
                          </Grid>
                        </Grid>
                      ))}
                      <Button variant="contained" color="primary" onClick={() => addMenuItem(day, meal)}>
                        Add {meal.charAt(0).toUpperCase() + meal.slice(1)} Item
                      </Button>
                    </Grid>
                  ))}
                </Grid>
              ))}
            </Grid>
          )}
        </Box>

        <Button type="submit" variant="contained" color="primary">
          {foodSupplier ? 'Update Food Supplier' : 'Create Food Supplier'}
        </Button>
      </form>
    </Paper>
	</div>
  );
};

export default CreateFoodSupplier;
